import {
    getProjects,
    getProjectQueue,
    getProjectActivity,
    getProjectContributors,
    getProjectDelayedTasks,
    getProjectBudgetReview,
    getProjectDetails
} from '../apiCaller';
import { _callAuthenticatedAPI } from '../apiCaller';
import { HTTPMethod } from 'src/enums/request';
import {
    ACTIVITIES_STATS_1,
    ACTIVITIES_STATS_2,
    IActivityRange
} from 'src/constants/activityStat';
import { IBudgetReviewFilter } from 'src/constants/budgetReview';

export const fetchProjects = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(getProjects());
        }, 300);
    });
};

export const fetchProjectDetails = (id: string) => getProjectDetails(id);

export const fetchProjectQueue = (id: string) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(getProjectQueue(id));
        }, 300);
    });
};

export const fetchProjectActivity = (id: string) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(getProjectActivity(id));
        }, 300);
    });
};

export const fetchProjectContributors = (id: string) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(getProjectContributors(id));
        }, 300);
    });
};

export const fetchProjectBudgetReview = (
    id: string,
    params?: IBudgetReviewFilter
) => getProjectBudgetReview(id, params);

export const fetchProjectDelayedTasks = (id: string) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(getProjectDelayedTasks(id));
        }, 300);
    });
};

export const fetchActivityStats = (params: IActivityRange) => {
    const date = new Date();
    date.setDate(date.getDate() - 13);
    return new Promise((resolve) => {
        setTimeout(() => {
            if (params.from && params.from > date) {
                resolve(ACTIVITIES_STATS_1);
            } else {
                resolve(ACTIVITIES_STATS_2);
            }
        }, 300);
    });
};

export const fetchProjectBudget = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(getProjectBudgetReview('1'));
        }, 300);
    });
};

export function getProjectLlmInfo(projectId: string): Promise<any> {
    const endpointUrl = `backend/api/v1/project/${projectId}/llm-info`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.GET);
}
